import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'
import FeedbackBlock from '~/components/common/feedback-block'
import ym from 'react-yandex-metrika'

const StillHaveQuestions = () => {
  return (
    <Screen
      title={<span>Остались<StyledScreen.GreenText> вопросы?</StyledScreen.GreenText></span>}
      className='still-have-questions'
    >
      <div className="still-have-questions__container">
        <p className="still-have-questions__subtitle">Оставьте заявку, наш менеджер свяжется с вами и проконсультирует по всем вопросам</p>
        <div className="still-have-questions__form">
          <Form
            formType='consultation'
            text='Хочу консультацию'
            isRedirect={false}
            onSubmit={() => {
              ym('reachGoal', 'consultation_chats', 631388)
            }}
          />
        </div>
        <FeedbackBlock title='Написать нам:' />
      </div>
    </Screen>
  );
};

export default StillHaveQuestions